import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { wines } from '@/mocks/products';
import { Link } from 'react-router-dom';

const WinesPage = () => {
  return (
    <>
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-24 md:pt-40 md:pb-32 overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/7a00092f4475fb707ada4ff32491da2b.jpg"
              alt="Parreirais da vinícola"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/50 to-black/30"></div>
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
            <span className="inline-block bg-white/15 text-white text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5 backdrop-blur-sm">
              Vinhos Artesanais
            </span>
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-5 max-w-xl leading-tight">
              Nossos Vinhos em Garrafa PET
            </h1>
            <p className="text-white/80 text-sm md:text-base max-w-md leading-relaxed mb-8">
              +de 6 rótulos cuidadosamente elaborados com uvas selecionadas. Do tinto encorpado ao branco delicado, temos o vinho perfeito para cada momento.
            </p>
            <a
              href="https://wa.me/5500000000000"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-2 bg-[#6B1E1E] text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-[#8B2E2E] transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-whatsapp-line"></i>
              Fazer Pedido pelo WhatsApp
            </a>
          </div>
        </section>

        {/* Wines Grid */}
        <section className="py-20 md:py-28" style={{ background: 'linear-gradient(135deg, #1a0508 0%, #2C0000 40%, #1a0a00 100%)' }}>
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-14">
              <div className="flex items-center justify-center gap-4 mb-4">
                <div className="w-12 h-px bg-[#878450]/50"></div>
                <i className="ri-goblet-line text-[#878450]"></i>
                <div className="w-12 h-px bg-[#878450]/50"></div>
              </div>
              <h2 className="text-2xl md:text-4xl font-bold text-[#FCF1D7]" style={{ fontFamily: "'Playfair Display', serif" }}>Conheça Nossa Linha de Vinhos</h2>

            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6 items-end" data-product-shop>
              {wines.map((wine, index) => {
                const bgImages = [
                  'https://public.readdy.ai/ai/img_res/edited_adfaf27c297ed2e9b4a63fcdfab78863_5b0e9cb3.jpg',
                  'https://public.readdy.ai/ai/img_res/edited_db8189690cae65be8c430be61fc1fa90_4860c490.jpg',
                  'https://public.readdy.ai/ai/img_res/edited_f06642b839770337f4a0f4afccb3dd48_7184528f.jpg',
                  'https://public.readdy.ai/ai/img_res/edited_8bff8163727e058a25f2276660687aef_93abf2f1.jpg',
                  'https://public.readdy.ai/ai/img_res/edited_e95419cd0fc62bcd4913b70720eabbd7_958c0318.jpg',
                ];
                return (
                  <div
                    key={wine.id}
                    className="group relative rounded-3xl overflow-hidden flex flex-col cursor-pointer transition-all duration-300 hover:-translate-y-2"
                    style={{ height: '680px' }}
                  >
                    {/* Background — blurred grape image */}
                    <div className="absolute inset-0 w-full h-full overflow-hidden">
                      <img
                        src={bgImages[index]}
                        alt={`Uvas para ${wine.name}`}
                        className="w-full h-full object-cover object-center"
                        style={{ filter: 'blur(3px) brightness(0.82)', transform: 'scale(1.06)', transition: 'transform 0.5s ease' }}
                      />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-[#2C0000]/95 via-[#2C0000]/30 to-[#2C0000]/10"></div>

                    {/* Tag */}
                    <div className="absolute top-5 left-5 z-20">
                      <span className="bg-[#710005]/90 backdrop-blur-sm text-[#FCF1D7] text-xs font-semibold px-3 py-1.5 rounded-full">
                        {wine.tag}
                      </span>
                    </div>

                    {/* Bottle Image */}
                    <div
                      className="absolute z-10 flex justify-center items-end"
                      style={{ top: '28px', left: 0, right: 0, height: '400px' }}
                    >
                      <img
                        src={wine.image}
                        alt={wine.name}
                        className="w-auto object-contain object-bottom transition-transform duration-500 group-hover:-translate-y-3"
                        style={{
                          height: '390px',
                          filter: 'drop-shadow(0 12px 28px rgba(0,0,0,0.7))',
                        }}
                      />
                    </div>

                    {/* Bottle base shadow */}
                    <div className="absolute z-10 left-0 right-0" style={{ bottom: '166px' }}>
                      <div className="mx-auto w-24 h-2 rounded-full bg-black/35 blur-sm"></div>
                    </div>

                    {/* Info */}
                    <div className="absolute bottom-0 left-0 right-0 z-20 p-6">
                      <p className="text-[#878450] text-xs font-semibold tracking-wider uppercase mb-1">{wine.type}</p>
                      <h3
                        className="text-[#FCF1D7] font-bold text-xl mb-2 leading-tight"
                        style={{ fontFamily: "'Playfair Display', serif" }}
                      >
                        {wine.name}
                      </h3>
                      <p className="text-[#FCF1D7]/60 text-xs leading-relaxed mb-4 line-clamp-2">{wine.description}</p>
                      <div className="flex items-center justify-between border-t border-[#878450]/20 pt-4">
                        <span className="text-xs text-[#FCF1D7]/45 bg-[#FCF1D7]/10 px-2.5 py-1 rounded-full">{wine.volume} · PET</span>
                        <a
                          href="https://wa.me/5500000000000"
                          target="_blank"
                          rel="nofollow noreferrer"
                          className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#878450] hover:text-[#FCF1D7] transition-colors cursor-pointer whitespace-nowrap"
                        >
                          <i className="ri-whatsapp-line"></i>
                          Pedir Agora
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Quality Section */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-2xl flex items-end justify-center gap-6 px-8 pt-8 overflow-hidden" style={{ height: 400 }}>
                  {/* Vineyard background */}
                  <div className="absolute inset-0 w-full h-full">
                    <img
                      src="https://readdy.ai/api/search-image?query=blurred-bokeh-background-large-dark-black-purple-grape-clusters-hanging-grapevine-lush-green-leaves-vineyard-ripe-harvest-deep-rich-color-soft-focus-dreamy-warm-golden-light-artisan-winery-organic-grapes-close-up-defocused&width=800&height=500&seq=vineyard-blurred-grapes-03&orientation=landscape"
                      alt="Videiras da vinícola"
                      className="w-full h-full object-cover object-center"
                      style={{ transform: 'scaleX(-1)' }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#2C0000]/80 via-[#2C0000]/35 to-[#2C0000]/50"></div>
                  </div>
                  {/* Bottles */}
                  <div className="relative z-10 flex flex-col items-center">
                    <img
                      src="https://public.readdy.ai/ai/img_res/28fb4aef-adfd-4098-9b31-07ca09819dc9.png"
                      alt="Vinho Bordô em garrafa de vidro 750ml"
                      className="w-auto object-contain"
                      style={{ height: 340 }}
                    />
                    <span className="text-[#FCF1D7] text-xs font-semibold mt-2 mb-3">750ml&nbsp;</span>
                  </div>
                  <div className="relative z-10 flex flex-col items-center">
                    <img
                      src="https://public.readdy.ai/ai/img_res/510206eb-3ea0-431a-b668-2e1347872b19.png"
                      alt="Vinho garrafa de vidro"
                      className="w-auto object-contain"
                      style={{ height: 340 }}
                    />
                    <span className="text-[#FCF1D7] text-xs font-semibold mt-2 mb-3">750ml&nbsp;</span>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-1/2">
                <span className="inline-block bg-[#f5ece8] text-[#6B1E1E] text-xs font-semibold px-3 py-1 rounded-full tracking-widest uppercase mb-5">
                  Nosso Processo
                </span>
                <h2 className="text-3xl md:text-4xl font-bold text-[#1a0a0a] mb-6 leading-snug">
                  Do Parreiral à Garrafa com Cuidado
                </h2>
                <div className="space-y-5">
                  {[
                    { icon: 'ri-seedling-line', title: 'Uvas Selecionadas', desc: 'Colhemos apenas as uvas no ponto certo de maturação para garantir o melhor sabor.' },
                    { icon: 'ri-flask-line', title: '', desc: 'Processo artesanal que preserva os aromas e características únicas de cada variedade.' },
                    { icon: 'ri-shield-check-line', title: 'Controle de Qualidade', desc: 'Cada lote é cuidadosamente analisado antes de chegar às mãos do cliente.' },
                  ].map((item) => (
                    <div key={item.title} className="flex gap-4">
                      <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#f5ece8] text-[#6B1E1E] flex-shrink-0">
                        <i className={`${item.icon} text-lg`}></i>
                      </div>
                      <div>
                        <h4 className="font-semibold text-[#1a0a0a] text-sm mb-1">{item.title}</h4>
                        <p className="text-[#7a5555] text-xs leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>



        {/* CTA */}
        <section className="py-16 bg-[#6B1E1E]">
          <div className="max-w-7xl mx-auto px-4 md:px-8 text-center">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Quer Fazer um Pedido?</h2>
            <p className="text-white/80 text-sm mb-8">Entre em contato pelos nossos canais e garanta já seu vinho favorito!</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="https://wa.me/5500000000000" target="_blank" rel="nofollow noreferrer" className="flex items-center gap-2 bg-white text-[#6B1E1E] px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/90 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-whatsapp-line"></i> WhatsApp
              </a>
              <Link to="/#contato" className="flex items-center gap-2 bg-white/15 text-white px-7 py-3.5 rounded-full font-semibold text-sm hover:bg-white/25 transition-all cursor-pointer whitespace-nowrap">
                <i className="ri-mail-line"></i> Enviar Mensagem
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default WinesPage;
